import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.enhancementsByJob>>;

export const createFetchJobEnhancementsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId }], signal }: TParams) =>
    call(() => cancelOnSignal(AdminService.getJobEnhancements({ jobId }), signal));
